'use strict';

require('../../includes/socialHandles.js');
require('../../modules/suggestion/includes.js');
require('./app.js');
require('./enums/channels.js');
require('./enums/channelStatus.js');
require('./views/matrixListItemPopover.js');
require('./views/matrixListItem.js');
require('./views/matrixListRow.js');
require('./views/matrixList.js');
require('./widgets/matrix.js');
